var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50877 16.5H0.280702V5.83333H3.64912V16.5H3.50877ZM1.96491 4.42982C0.842105 4.42982 0 3.44737 0 2.46491C0 1.3421 0.842105 0.5 1.96491 0.5C3.08772 0.5 3.92982 1.3421 3.92982 2.46491C3.78947 3.44737 2.94737 4.42982 1.96491 4.42982ZM16 16.5H12.6316V11.307C12.6316 10.0439 12.6316 8.5 10.9474 8.5C9.26316 8.5 8.98246 9.90351 8.98246 11.307V16.4997H5.61403V5.83333H8.8421V7.23684C9.26316 6.39474 10.386 5.55263 11.9298 5.55263C15.2982 5.55263 15.8596 7.79824 15.8596 10.6053V16.5H16Z",
    fill: "#8591A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dfb6c877444533c386a1d85f03a9e675.svg";
export { ForwardRef as ReactComponent };